import React from 'react';
import { hasRelationship } from 'Helpers/Affordances';
import fr from 'facet-rest';
import AnnualReviewCardPicker from 'Views/Dashboard/AnnualInvestmentsReviewSectionPicker';
import AccountOpeningCardPicker from 'Views/Dashboard/AccountOpeningCardPicker';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import {
  FDBox, FDContentContainer, FDPaper, FDStack,
} from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';
import EstatePlanningCardPicker from 'Views/Dashboard/EstatePlanningCardPicker';
import { useDashboardContext } from 'Views/Dashboard/DashboardContext';
import { useRefreshDashboardContent } from 'Hooks/useRefreshEvent';

const HighPriorityTasksSection = () => {
  const { householdResource } = useSimpleHousehold();
  const { clientDashboardResource, refreshClientDashboardResource } = useDashboardContext();
  const isMobile = useMobileLayout();

  const showSection = hasRelationship(householdResource, fr.relationships.annualInvestmentReview.name)
      || hasRelationship(householdResource, fr.relationships.accountOpeningStartPage.name)
      || hasRelationship(clientDashboardResource, fr.relationships.estatePlanningRecommendation.name);

  useRefreshDashboardContent(() => {
    refreshClientDashboardResource();
  }, [clientDashboardResource]);

  if (!showSection) return null;
  return (
    <FDPaper width="100%" color="subtle" appearance="flat" rounded={false}>
      <FDBox paddingY={4}>{/* FDPaper doesn't support paddingY, and I don't want to touch paddingX because that messes with the horizontal alignment on mobile */}
        <FDContentContainer maxWidth="xl">
          <FDStack direction="row" wrap spacing={isMobile ? 4 : 6} justifyContent="center">
            <AnnualReviewCardPicker />
            <AccountOpeningCardPicker />
            <EstatePlanningCardPicker />
          </FDStack>
        </FDContentContainer>
      </FDBox>
    </FDPaper>
  );
};

export default HighPriorityTasksSection;
